/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { InsightsDriverBreakdownOvertimeDtoEdgeModel, InsightsDriverBreakdownOvertimeDtoEdgeModelType } from "./InsightsDriverBreakdownOvertimeDtoEdgeModel"
import { InsightsDriverBreakdownOvertimeDtoEdgeModelSelector } from "./InsightsDriverBreakdownOvertimeDtoEdgeModel.base"
import { InsightsDriverBreakdownOvertimeDtoModel, InsightsDriverBreakdownOvertimeDtoModelType } from "./InsightsDriverBreakdownOvertimeDtoModel"
import { InsightsDriverBreakdownOvertimeDtoModelSelector } from "./InsightsDriverBreakdownOvertimeDtoModel.base"
import { RootStoreType } from "./index"


/**
 * CompletedRoutesInsightsDriverBreakdownOvertimePaginatedDtoBase
 * auto generated base class for the model CompletedRoutesInsightsDriverBreakdownOvertimePaginatedDtoModel.
 */
export const CompletedRoutesInsightsDriverBreakdownOvertimePaginatedDtoModelBase = ModelBase
  .named('CompletedRoutesInsightsDriverBreakdownOvertimePaginatedDto')
  .props({
    __typename: types.optional(types.literal("CompletedRoutesInsightsDriverBreakdownOvertimePaginatedDto"), "CompletedRoutesInsightsDriverBreakdownOvertimePaginatedDto"),
    edges: types.union(types.undefined, types.null, types.array(types.late((): any => InsightsDriverBreakdownOvertimeDtoEdgeModel))),
    nodes: types.union(types.undefined, types.null, types.array(types.late((): any => InsightsDriverBreakdownOvertimeDtoModel))),
    totalCount: types.union(types.undefined, types.integer),
    hasNextPage: types.union(types.undefined, types.boolean),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class CompletedRoutesInsightsDriverBreakdownOvertimePaginatedDtoModelSelector extends QueryBuilder {
  get totalCount() { return this.__attr(`totalCount`) }
  get hasNextPage() { return this.__attr(`hasNextPage`) }
  edges(builder: string | InsightsDriverBreakdownOvertimeDtoEdgeModelSelector | ((selector: InsightsDriverBreakdownOvertimeDtoEdgeModelSelector) => InsightsDriverBreakdownOvertimeDtoEdgeModelSelector) | undefined) { return this.__child(`edges`, InsightsDriverBreakdownOvertimeDtoEdgeModelSelector, builder) }
  nodes(builder: string | InsightsDriverBreakdownOvertimeDtoModelSelector | ((selector: InsightsDriverBreakdownOvertimeDtoModelSelector) => InsightsDriverBreakdownOvertimeDtoModelSelector) | undefined) { return this.__child(`nodes`, InsightsDriverBreakdownOvertimeDtoModelSelector, builder) }
}
export function selectFromCompletedRoutesInsightsDriverBreakdownOvertimePaginatedDto() {
  return new CompletedRoutesInsightsDriverBreakdownOvertimePaginatedDtoModelSelector()
}

export const completedRoutesInsightsDriverBreakdownOvertimePaginatedDtoModelPrimitives = selectFromCompletedRoutesInsightsDriverBreakdownOvertimePaginatedDto().totalCount.hasNextPage
